<template>
    <v-dialog v-model="open" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <div v-if="description">{{ description }}</div>
          <div v-if="errors.length">
            <ul>
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="handleClose">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  export default {
    props: {
      open: {
        type: Boolean,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      description: {
        type: String,
        default: ''
      },
      errors: {
        type: Array,
        required: true
      }
    },
    methods: {
      handleClose() {
        this.$emit('update:open', false);
        this.$emit('close');
      }
    }
  };
  </script>
  
  <style scoped>
  .headline {
    font-weight: bold;
  }
  </style>